import { Box, Stack, Typography } from '@mui/material';
import { PersonOutlineOutlined as PersonIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import MicrosoftIcon from '../../../Assets/icons/MicrosoftIcon';

// eslint-disable-next-line react/prop-types
const TypeStep = ({ inviteType, onSelect }) => {
  const { t } = useTranslation('users');

  return (
    <Stack spacing={2}>
      <Typography sx={{ fontSize: 13, color: 'text.secondary' }}>{t('invite.typeSubtitle')}</Typography>
      <Stack direction="row" spacing={1.5}>
        <Box
          onClick={() => onSelect('entra')}
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            gap: 1.25,
            p: 2.25,
            borderRadius: 2,
            cursor: 'pointer',
            border: '2px solid',
            borderColor: inviteType === 'entra' ? 'primary.main' : 'divider',
            bgcolor: inviteType === 'entra' ? 'primary.50' : 'background.paper',
            '&:hover': { borderColor: 'primary.main' },
          }}
        >
          <MicrosoftIcon size={36} />
          <Box>
            <Typography sx={{ fontWeight: 600, fontSize: 13 }}>{t('invite.typeEntra')}</Typography>
            <Typography sx={{ fontSize: 11, color: 'text.secondary', mt: 0.5, lineHeight: 1.4 }}>{t('invite.typeEntraDesc')}</Typography>
          </Box>
        </Box>
        <Box
          onClick={() => onSelect('local')}
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            gap: 1.25,
            p: 2.25,
            borderRadius: 2,
            cursor: 'pointer',
            border: '2px solid',
            borderColor: inviteType === 'local' ? 'primary.main' : 'divider',
            bgcolor: inviteType === 'local' ? 'primary.50' : 'background.paper',
            '&:hover': { borderColor: 'primary.main' },
          }}
        >
          <PersonIcon sx={{ fontSize: 36, color: 'primary.main' }} />
          <Box>
            <Typography sx={{ fontWeight: 600, fontSize: 13 }}>{t('invite.typeLocal')}</Typography>
            <Typography sx={{ fontSize: 11, color: 'text.secondary', mt: 0.5, lineHeight: 1.4 }}>{t('invite.typeLocalDesc')}</Typography>
          </Box>
        </Box>
      </Stack>
    </Stack>
  );
};

export default TypeStep;
